export const cmdSymbol = Symbol('cmds');
